module.exports = __webpack_public_path__ + "img/view-corner.f0e7cd5c.svg";